module.exports = __webpack_public_path__ + "img/smtp.fd9a5597.svg";